import { isLocalhost } from '../modules/utilities';

export const handleSaveEvent = (e) => {
  const saveUrl = '/maa-api/saveditems/v1/communities/';
  const saveFloorPlanUrl = '/maa-api/saveditems/v1/floorplans/';
  const target = e.currentTarget;
  const communityId = target.getAttribute('data-id');
  const isSaved = !target.classList.contains('saved');
  const useCookie = target.hasAttribute('data-cookie') ? true : false;
  let saveType;

  const toggleIcon = () => {
    document.querySelectorAll('[data-id="' + communityId + '"][href="#save"]').forEach((item) => {
      item.classList.toggle('saved');
    });
  }

  e.preventDefault();
  if (isLocalhost()) {
    toggleIcon();
  }

  const decreaseCounter = () => {
    document.querySelectorAll('.nav__quick-access--total').forEach(el => {
      if (el.dataset.total > 0) {
        el.dataset.total = (el.dataset.total - 1).toString();
      }
    });
  }

  const increaseCounter = () => {
    document.querySelectorAll('.nav__quick-access--total').forEach(el => {
      el.dataset.total = (+el.dataset.total + 1).toString();
    });
  }

  if(useCookie) { //FLOORPLAN
    saveType = "floorplan";
    // UPDATE BACKEND

    if(!isLocalhost()){
      fetch(saveFloorPlanUrl + communityId, {
        method: isSaved ? 'POST' : 'DELETE',
      })
        .then(response => response.json())
        .then((res) => {
          if (res !== "No item was added!" && res !== "No item was removed!") {
            toggleIcon();
            if (isSaved) {
              increaseCounter();
            } else {
              decreaseCounter();
            }
          }
        })
        .catch(console.error);
    } else {
      console.log('Localhost');
    }
  } else { // COMMUNITY
    saveType = "community";
    // UPDATE MASTER COMMUNITY ARRAY (if available)

    // UPDATE BACKEND
    if(!isLocalhost()){
      fetch(saveUrl + communityId, {
        method: isSaved ? 'POST' : 'DELETE',
      })
        .then(response => response.json())
        .then((res) => {
          console.log(res);
          toggleIcon();
          if (isSaved) {
            increaseCounter();
          } else {
            decreaseCounter();
          }
        })
        .catch(console.error);
    }
  }

  // DISPATCH EVENT FOR SAVED LIST (if available)
  document.dispatchEvent(new CustomEvent("updateSave", {
    bubbles: true,
    detail: {
      Id: communityId,
      IsSaved: isSaved,
      Type: saveType
    }
  }));

  if (isLocalhost()) {
    if (isSaved) {
      increaseCounter();
    } else {
      decreaseCounter();
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/components/save-community.js